import { useToast } from '@chakra-ui/react';
import { QueryKey, useQuery } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { useAxios } from 'context/AxiosContextProvider';
import { manageErrorResponse } from 'helpers/manageErrorResponse';
import { useEffect } from 'react';

import { Permission } from '../api/types';
import config from '../config';

async function getAllPermissions(axios: AxiosInstance): Promise<Permission[]> {
  const { data } = await axios.get(`${config.apiBaseUrl}/op/v1/permissions`);

  return data;
}

export default function useAllPermissionsQuery() {
  const axios = useAxios();
  const toast = useToast();

  const query = useQuery({
    // eslint-disable-next-line @tanstack/query/exhaustive-deps
    queryKey: getKey(),
    queryFn: () => getAllPermissions(axios),
    notifyOnChangeProps: ['data', 'isFetching', 'error'],
    retry: false,
  });

  useEffect(() => {
    if (query.isError) {
      manageErrorResponse(toast, JSON.stringify(query.error));
    }
  }, [query.error, query.isError, toast]);

  return query;
}

function getKey(): QueryKey {
  return ['Permission'];
}

useAllPermissionsQuery.getKey = getKey;
